<template>
  <j-modal
    title="添加事件"
    :width="600"
    :visible="visible"
    :mask="true"
    :fullscreen="izMobile"
    class="j-super-query-modal"
    style="top: 5%; max-height: 95%"
    ok-text="保存"
    @cancel="handleCancel"
    @ok="handleOk"
  >
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="选择时间" prop="time">
        <j-date v-model="form.time" placeholder="请选择日期" style="width: 100%" />
      </a-form-model-item>
      <a-form-model-item label="选择曲线" prop="currLine">
        <a-select v-model="form.currLine" placeholder="请选择曲线名称" :options="lineOptions" />
      </a-form-model-item>
      <a-form-model-item label="选择类型" prop="eventsType">
        <a-select
          v-model="form.eventsType"
          placeholder="请选择事件类型"
          :options="eventsTypeOpts"
        />
      </a-form-model-item>
      <a-form-model-item label="事件内容" :wrapperCol="{ span: 20 }" prop="eventsContent">
        <a-input
          v-model="form.eventsContent"
          type="textarea"
          style="width: 100%"
          placeholder="请输入事件内容"
          :auto-size="{ minRows: 5, maxRows: 8 }"
        />
      </a-form-model-item>
    </a-form-model>
  </j-modal>
</template>

<script>
import JDate from '@/components/jeecg/JDate.vue'
import { postAction } from '@api/manage'
import moment from 'moment'

export default {
  name: 'AddEventModal',
  components: {
    JDate,
  },
  props: {},
  data() {
    return {
      visible: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      rules: {
        time: [{ required: true, message: '日期不能为空', trigger: 'blur' }],
        currLine: [{ required: true, message: '曲线不能为空', trigger: 'blur' }],
        eventsType: [{ required: true, message: '事件类型不能为空', trigger: 'blur' }],
        eventsContent: [{ required: true, message: '事件内容不能为空', trigger: 'blur' }],
      },
      form: {
        time: '',
        currLine: '',
        eventsType: '',
        eventsContent: '',
      },
      addEventId: '',
      pointRecord: {},
      eventsTypeOpts: [
        {
          label: '心理辅导',
          value: 1,
        },
        {
          label: '班级考试',
          value: 2,
        },
        {
          label: '班级活动',
          value: 3,
        },
        {
          label: '年级活动',
          value: 4,
        },
        {
          label: '校园活动',
          value: 5,
        },
        {
          label: '工作会议',
          value: 6,
        },
        {
          label: '其他',
          value: 7,
        },
      ],
      lineOptions: [],
      optionalDates: [],
      allLinesData: [],
    }
  },
  computed: {
    izMobile() {
      return this.device === 'mobile'
    },
  },
  methods: {
    show(data, fields) {
      // console.log('showdata--', data, fields)
      this.visible = true
      this.allLinesData = data.length ? data : []
      this.lineOptions = fields.length ? fields.filter(item => !item.startsWith("往期")).map((item) => ({ label: item, value: item })) : []
      this.optionalDates = data.length
        ? data.map((item) => moment(item.type).format('YYYY-MM-DD'))
        : []

      // console.log('所有日期：', this.optionalDates)
      // console.log('曲线可选：', this.lineOptions)
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleCancel() {
      this.close()
      this.$refs.ruleForm.resetFields()
    },
    disabledDate(date) {
      const currDate = moment(date).format('YYYY-MM-DD')
      if (this.optionalDates.includes(currDate)) {
        return false
      }
      return true
    },
    handleOk() {
      const filterObj = this.allLinesData.filter((item) => {
        return (
          item.type == this.form.time &&
          item[this.form.currLine] != undefined &&
          item[this.form.currLine + 'id'] != undefined
        )
      })
      if (filterObj.length) {
        this.pointRecord = filterObj[0]
        this.$set(this.pointRecord, 'filed', this.form.currLine)
        this.$set(this.pointRecord, 'id', this.pointRecord[this.form.currLine + 'id'])
        this.$set(this.pointRecord, 'incident', this.pointRecord[this.form.currLine + 'incident'])
        // this.$set(this.pointRecord, 'incident', 1)
      }
      this.$emit('refresh', this.pointRecord)

      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const queryData = {
            eventsId: this.pointRecord.id,
            eventsType: this.form.eventsType,
            eventsContent: this.form.eventsContent,
            eventTimePeriod: this.form.time,
          }

          postAction('/dataEvents/add', queryData).then((res) => {
            if (res.code && res.success) {
              this.$message.success(res.result || '操作成功')
              // 抛出事件设置标识
              this.$emit('refresh', this.pointRecord)
              this.close()
              this.$refs.ruleForm.resetFields()
              return
            }
            this.$message.error(res.result || '操作失败')
          })
        }
      })
    },
  },
}
</script>

<style></style>
